import type { MessageDescriptor } from 'react-intl';
import {
  OUTREACH_INBOX_GROUPS,
  type OutreachInboxGroup,
  type OutreachReplyAsk,
} from 'fym-shared/src/music24/outreach/types';
import type { InboxCounts, ReplyRow } from '../outreachTypes';
import { inboxMessages as m } from './inboxMessages';

/** The groups of the inbox in list order (design outreach-v2 m1). The API sets `row.group`. */
export const INBOX_GROUP_ORDER: readonly OutreachInboxGroup[] = OUTREACH_INBOX_GROUPS;

export const INBOX_GROUP_TEXT: Record<OutreachInboxGroup, MessageDescriptor> = {
  needsYou: m.groupNeedsYou,
  added: m.groupAdded,
  done: m.groupDone,
  hidden: m.groupHidden,
};

/** The short ask words of a list row ("Asks: link, date"). */
export const ASK_SHORT_TEXT: Record<OutreachReplyAsk, MessageDescriptor> = {
  link: m.askShortLink,
  releaseDate: m.askShortReleaseDate,
  wav: m.askShortWav,
  pressPhoto: m.askShortPressPhoto,
  lyrics: m.askShortLyrics,
  story: m.askShortStory,
  other: m.askShortOther,
};

/** The ask chips of a thread ("They ask for: Spotify link, Release date"). */
export const ASK_TEXT: Record<OutreachReplyAsk, MessageDescriptor> = {
  link: m.askLink,
  releaseDate: m.askReleaseDate,
  wav: m.askWav,
  pressPhoto: m.askPressPhoto,
  lyrics: m.askLyrics,
  story: m.askStory,
  other: m.askOther,
};

/** The loaded rows per group, in the order of the API (newest first). */
export function groupInboxRows(rows: readonly ReplyRow[]): Record<OutreachInboxGroup, ReplyRow[]> {
  const groups: Record<OutreachInboxGroup, ReplyRow[]> = { needsYou: [], added: [], done: [], hidden: [] };
  rows.forEach((row) => groups[row.group].push(row));
  return groups;
}

/**
 * The number in each group head. `counts.byGroup` counts every reply of the artist and ignores the
 * campaign filter, so with a campaign filter the head counts the loaded rows instead.
 */
export function inboxGroupCounts(
  counts: InboxCounts | null,
  groups: Record<OutreachInboxGroup, ReplyRow[]>,
  campaignFiltered: boolean
): Record<OutreachInboxGroup, number> {
  if (counts !== null && !campaignFiltered) {
    return counts.byGroup;
  }
  return {
    needsYou: groups.needsYou.length,
    added: groups.added.length,
    done: groups.done.length,
    hidden: groups.hidden.length,
  };
}
